<template>
    <LayoutLanding class="automation-landing">
        <template #content>
            <div class="automation-landing__content">
                <div class="automation-landing__title-section">
                    <h1 class="automation-landing__title typographies-display-brand-medium">
                        {{ translations.title }}
                    </h1>
                    <p class="automation-landing__subtitle typographies-paragraph-medium-regular">
                        {{ translations.subtitle }}
                    </p>
                </div>
                <div class="automation-landing__actions">
                    <p
                        class="automation-landing__actions-title typographies-paragraph-caps-medium-black"
                    >
                        {{ translations.titleActions }}
                    </p>
                    <AutomationLandingCard
                        v-for="card in cards"
                        :key="card.id"
                        :icon="card.icon"
                        :title="card.title"
                        :caption="card.caption"
                        :dataBot="card.dataBot"
                        @click="handleCardClick(card.id)"
                    />
                </div>
            </div>
        </template>
        <template #illustration>
            <picture>
                <source :srcset="illustrationSmallSrc" media="(max-width: 1279px)" />
                <img
                    :src="illustrationDefaultSrc"
                    alt="Automation Illustration"
                    class="automation-landing__illustration"
                />
            </picture>
        </template>
    </LayoutLanding>
</template>

<script>
import LayoutLanding from 'vcomponents/common/layout/LayoutLanding.vue';
import AutomationLandingCard from './AutomationLandingCard.vue';
import { createAutomation } from 'api/automation/automationService';
import Feature from 'Services/Feature';

import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    components: {
        LayoutLanding,
        AutomationLandingCard,
    },
    data() {
        return {
            translations: {
                title: this.$t.__('automation.AutomationLanding.title'),
                subtitle: this.$t.__('automation.AutomationLanding.subtitle'),
                titleActions: this.$t.__('automation.AutomationLanding.title_actions'),
            },
            cardsData: [
                {
                    id: 'templates',
                    icon: 'obj-slsy-basic-automation',
                    title: this.$t.__('automation.AutomationLanding.card_templates_title'),
                    caption: this.$t.__('automation.AutomationLanding.card_templates_caption'),
                    dataBot: 'automation__landingpage--browsemodel',
                },
                {
                    id: 'services',
                    icon: 'obj-slsy-advanced-services',
                    title: this.$t.__('automation.AutomationLanding.card_services_title'),
                    caption: this.$t.__('automation.AutomationLanding.card_services_caption'),
                    dataBot: 'automation__landingpage--askhelp',
                },
                {
                    id: 'custom',
                    icon: 'obj-slsy-advanced-automation',
                    title: this.$t.__('automation.AutomationLanding.card_custom_title'),
                    caption: this.$t.__('automation.AutomationLanding.card_custom_caption'),
                    dataBot: 'automation__landingpage--customautomation',
                },
            ],
            isLoading: false,
        };
    },
    computed: {
        ...mapStateUser(['uiLang']),
        ...mapStateSystem(['errorsHandler']),
        hasAutomationBuilderFeature() {
            return Feature.isEnabled('automations-builder');
        },
        cards() {
            return this.cardsData.filter((card) => {
                if (card.id === 'custom') {
                    return this.hasAutomationBuilderFeature;
                }
                return true;
            });
        },
        userLanguage() {
            return this.uiLang === 'fr' ? 'fr' : 'en';
        },
        illustrationDefaultSrc() {
            return `/ressources/logged/img/illustrations/automations/automation-illustration-default-${this.userLanguage}.svg`;
        },
        illustrationSmallSrc() {
            return `/ressources/logged/img/illustrations/automations/automation-illustration-small-${this.userLanguage}.svg`;
        },
    },
    methods: {
        handleCardClick(cardId) {
            switch (cardId) {
                case 'templates':
                    this.handleGoToTemplates();
                    break;
                case 'services':
                    window.open('https://go.sellsy.com/demande-info-sellsy-services', '_blank');
                    break;
                case 'custom':
                    this.handleCreateAutomation();
                    break;
                default:
                    break;
            }
        },
        handleGoToTemplates() {
            if (this.$route.name === 'automations.templates') {
                return;
            }
            this.$router.push({
                name: 'automations.templates',
            });
        },
        handleCreateAutomation() {
            this.isLoading = true;
            createAutomation()
                .then((response) => {
                    if (response) {
                        this.$router.push({
                            name: 'automations.flow.builder',
                            params: { id: response.data.id },
                        });
                    }
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('automation.AutomationLayout.error.create_automation'),
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.automation-landing {
    &__content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-5);
    }
    &__title-section {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
    }
    &__title,
    &__subtitle {
        margin: 0;
        color: var(--colors-common-text-brand-secondary-blue);
    }
    &__actions {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-2);
    }
    &__actions-title {
        margin: 0;
        color: var(--colors-common-text-standard-default);
    }
}
</style>
